import NoteFontSize from '../editor-components/note-font-size';
import NoteTextDesign from '../editor-components/note-text-design';
import NoteLists from '../editor-components/note-lists';
import NoteTextAlign from '../editor-components/note-text-align';
import NoteObjects from '../editor-components/note-objects';
import NoteMedia from '../editor-components/note-media';
import NoteBlocks from '../editor-components/note-blocks';
import NoteTextStyle from '../editor-components/note-text-style';
import NoteFontStyle from '../editor-components/note-font-style';
import NoteHistory from '../editor-components/note-history';
import { Editor } from '@tiptap/react';
import { Box, Divider, Paper, Stack } from '@mui/material';

import { memo, useCallback } from 'react';


interface NoteActionTabProp {
  editor: Editor;
  mode: number;
}


function NoteActionTab({ editor, mode }: NoteActionTabProp) {
  const VerticalDivider = useCallback(() => {
    return (
      <Divider
        orientation="vertical"
        sx={{
          height: 32,
          width: '1px',
          marginLeft: 1.5,
          marginRight: 1.5,
          backgroundColor: mode === 1 
            ? 'rgba(0, 0, 0, 0.08)' 
            : 'rgba(255, 255, 255, 0.12)',
          alignSelf: 'center'
        }}
      />
    );
  }, [mode]);

  const toolbarGroups = [
    { component: <NoteHistory editor={editor} mode={mode} />, key: 'history' },
    { 
      component: (
        <Stack direction="row" alignItems="center">
          <NoteTextStyle editor={editor} mode={mode} />
          <NoteFontStyle editor={editor} mode={mode} />
        </Stack>
      ), 
      key: 'text-style' 
    },
    { component: <NoteFontSize editor={editor} mode={mode} />, key: 'font-size' },
    { component: <NoteTextDesign editor={editor} mode={mode} />, key: 'text-design' },
    { component: <NoteLists editor={editor} mode={mode} />, key: 'lists' },
    { component: <NoteTextAlign editor={editor} mode={mode} />, key: 'text-align' },
    { component: <NoteObjects editor={editor} mode={mode} />, key: 'objects' },
    { component: <NoteMedia editor={editor} mode={mode} />, key: 'media' },
    { component: <NoteBlocks editor={editor} mode={mode} />, key: 'blocks' },
  ];

  return (
   <Paper
      elevation={mode === 1 ? 1 : 0}
      sx={{
        background: mode === 1 
          ? 'rgb(221, 230, 235)' 
          : 'rgba(113, 131, 161, 0.95)',
        backdropFilter: 'blur(12px)',
        border: mode === 1 
          ? '1px solid rgba(0, 0, 0, 0.06)'
          : '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: 3,
        boxShadow: mode === 1 
          ? '0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06)'
          : '0 4px 16px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08)',
      }}
    >

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          overflowX: 'auto',
          overflowY: 'hidden',
          paddingX: 2,
          minHeight: 44,
        }}
      >
        {toolbarGroups.map((group, index) => (
          <Box key={group.key} sx={{ display: 'flex'}}>
            {group.component}
            {index < toolbarGroups.length - 1 && <VerticalDivider />}
          </Box>
        ))}
      </Box>
    </Paper>
  );
}

export default memo(NoteActionTab);